import React, { useMemo } from 'react';
import LabelValueCard from 'components/__SHARED__/LabelValueCard/LabelValueCard';
import {
  Button,
  ButtonThemes,
  Col,
  RefreshIcon,
  Row,
} from 'plataforma-fundacao-componentes';
import { languageValues } from 'helpers/utils/languageUtils';

interface Props {
  loading: boolean;
  atualizar: () => void;
  usuariosLoagdos: number;
  contasCapital: number;
  presentes: number;
  convidados: number;
  quorumAtingido: boolean;
  isAGN: boolean;
  aptos?: number;
}

export default function Totais({
  loading,
  atualizar,
  usuariosLoagdos,
  contasCapital,
  presentes,
  convidados,
  quorumAtingido,
  isAGN,
  aptos,
}: Props) {
  const language = languageValues.pages.presents;

  const quorumAtingidoValue = useMemo(() => {
    if (quorumAtingido) {
      return language.yes;
    }
    return language.no;
  }, [language, quorumAtingido]);

  return (
    <Row>
      <Col>
        <Button
          theme={ButtonThemes.Secondary}
          onClick={atualizar}
          leftIcon={<RefreshIcon animate={false} />}
          disabled={loading}
          loading={loading}
        >
          {language.buttons.refreshPeoples}
        </Button>
      </Col>
      <Row>
        <Col cols={[6, 6, 6, 2, 2]}>
          <LabelValueCard
            label={language.cards.quorumReached}
            value={quorumAtingidoValue}
          />
        </Col>
        <Col cols={[6, 6, 6, 2, 2]}>
          <LabelValueCard
            label={language.cards.onlineParticipants}
            value={usuariosLoagdos}
          />
        </Col>
        <Col cols={[6, 6, 6, 2, 2]}>
          <LabelValueCard
            label={language.cards.associates}
            value={contasCapital}
          />
        </Col>
        {isAGN ? (
          <Col cols={[6, 6, 6, 2, 2]}>
            <LabelValueCard
              label={language.cards.eligibleAssociates}
              value={aptos}
            />
          </Col>
        ) : undefined}
        <Col cols={[6, 6, 6, 2, 2]}>
          <LabelValueCard
            label={language.cards.presentPeople}
            value={presentes}
          />
        </Col>
        <Col cols={[isAGN ? 6 : 12, isAGN ? 6 : 12, isAGN ? 6 : 12, 2, 2]}>
          <LabelValueCard label={language.cards.guest} value={convidados} />
        </Col>
      </Row>
    </Row>
  );
}
